import Contents from "@/components/Home/Contents";
import { Body } from "./style";
import Join from "../Membership/Join/Index";
import Header from "@/components/Header/Index";
const Home = () => {
  return (
    <>
      <Header />
      <Body>
        <Contents name="강아지" />
        <Contents name="음식" />
        <Contents name="스팀게임" />
        <Contents name="고양이" />
        <Contents name="디저트" />
      </Body>
      {/* <Join /> */}
    </>
  );
};

export default Home;
